import React, { useState } from "react";

import { ChevronUp, ChevronDown } from "lucide-react";

import "./style.scss";
import Button from "../Button";

interface AccordionProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
  onClick?: (isOpen: boolean) => void;
  iconPosition?: "before" | "after";
  className?: string;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
  isOpen: controlledIsOpen,
  onToggle,
  onClick,
  iconPosition = "after",
  className,
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isControlled = controlledIsOpen !== undefined;
  const isOpen = isControlled ? controlledIsOpen : internalOpen;

  const toggle = () => {
    const newState = !isOpen;
    if (!isControlled) {
      setInternalOpen(newState);
    }
    onToggle?.(newState);
    onClick?.(newState);
  };

  const IconComponent = isOpen ? ChevronUp : ChevronDown;

  return (
    <div className={`accordion-wrapper rounded-lg ${className || ""}`}>
      <Button
        variant="clear"
        className="accordion-header w-full gap-1"
        onClick={toggle}
      >
        {iconPosition === "before" && (
          <IconComponent className="w-5 h-5 text-gray-500" strokeWidth={1.5} />
        )}
        <div className="w-full">{title}</div>
        {iconPosition === "after" && (
          <IconComponent className="w-5 h-5 text-gray-500" strokeWidth={1.5} />
        )}
      </Button>
      <div
        className={`accordion-body overflow-hidden transition-all duration-300 ${
          isOpen ? "opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
